import { jsx, jsxs } from "react/jsx-runtime";
import { CdnIcon, Divider, IconToggleButton, Image, cn } from "@pcln/horizon";
import { recentSelectionVariants } from "../../RecentSelection.variants.js";
import { CTAButtons, DateBlock, OccupancySection, ReviewsSection } from "../../common/shared.js";
function RentalCarSelection({ buttonText = 'Book Now', brandImg, className, dropOff, headline, imageSrc, isFavorite, numAdults, onClick, onFavoriteToggle, passengerCount, passengerText, pickUp, pickupLocation, reviews }) {
    const parsedNumAdults = 'number' == typeof numAdults ? numAdults : Number(numAdults);
    const resolvedPassengerCount = 'number' == typeof passengerCount && Number.isFinite(passengerCount) ? passengerCount : Number.isFinite(parsedNumAdults) ? parsedNumAdults : 0;
    const resolvedPassengerText = passengerText ?? `${resolvedPassengerCount} Passenger${1 === resolvedPassengerCount ? '' : 's'}`;
    const { attributeRow, bottomSection, card, contentWrapper, dateBlockDividerHorizontal, dateBlockDividerVertical, dateBlocksContainer, favoriteButton, image, imageContainer, infoSection, logoOverlay, middleSection, root, subtitle, title, topSection } = recentSelectionVariants({
        productType: 'rentalCar'
    });
    return /*#__PURE__*/ jsx("div", {
        className: cn(root(), className),
        children: /*#__PURE__*/ jsx("div", {
            className: card(),
            onClick: onClick,
            children: /*#__PURE__*/ jsxs("div", {
                className: contentWrapper(),
                children: [
                    onFavoriteToggle && /*#__PURE__*/ jsx("div", {
                        className: favoriteButton(),
                        children: /*#__PURE__*/ jsx(IconToggleButton, {
                            ariaLabel: "Favorite this rental car",
                            emphasis: "bold",
                            isAnimated: true,
                            isToggledOn: isFavorite,
                            onToggle: onFavoriteToggle,
                            palette: "favorite",
                            size: "24"
                        })
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: topSection(),
                        children: [
                            /*#__PURE__*/ jsxs("div", {
                                className: cn(imageContainer(), 'pt-1 pl-1'),
                                children: [
                                    /*#__PURE__*/ jsx(Image, {
                                        alt: headline,
                                        className: image(),
                                        objectFit: "contain",
                                        src: imageSrc || ''
                                    }),
                                    brandImg && /*#__PURE__*/ jsx("div", {
                                        className: logoOverlay(),
                                        children: /*#__PURE__*/ jsx(Image, {
                                            alt: "Rental company",
                                            className: "h-10 w-auto",
                                            src: brandImg
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: infoSection(),
                                children: [
                                    /*#__PURE__*/ jsx("div", {
                                        className: title(),
                                        children: headline
                                    }),
                                    /*#__PURE__*/ jsxs("div", {
                                        className: attributeRow(),
                                        children: [
                                            /*#__PURE__*/ jsx(CdnIcon, {
                                                className: "text-neutral-13",
                                                iconName: "location_on",
                                                size: "16"
                                            }),
                                            /*#__PURE__*/ jsx("div", {
                                                className: subtitle(),
                                                children: pickupLocation
                                            })
                                        ]
                                    }),
                                    reviews && /*#__PURE__*/ jsx(ReviewsSection, {
                                        reviews: reviews
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: middleSection(),
                        children: [
                            /*#__PURE__*/ jsxs("div", {
                                className: dateBlocksContainer(),
                                children: [
                                    /*#__PURE__*/ jsx(DateBlock, {
                                        dateInfo: pickUp,
                                        label: "Pick up",
                                        productType: "rentalCar"
                                    }),
                                    /*#__PURE__*/ jsx(Divider, {
                                        className: dateBlockDividerVertical(),
                                        direction: "vertical"
                                    }),
                                    /*#__PURE__*/ jsx(Divider, {
                                        className: dateBlockDividerHorizontal(),
                                        direction: "horizontal"
                                    }),
                                    /*#__PURE__*/ jsx(DateBlock, {
                                        dateInfo: dropOff,
                                        label: "Drop off",
                                        productType: "rentalCar"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ jsxs("div", {
                                className: bottomSection(),
                                children: [
                                    /*#__PURE__*/ jsx(OccupancySection, {
                                        iconName: "person",
                                        text: resolvedPassengerText
                                    }),
                                    /*#__PURE__*/ jsx(CTAButtons, {
                                        buttonText: buttonText,
                                        onClick: onClick
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
export { RentalCarSelection };
